<template>
  <div class="ma-10">
    <Loading v-if="isLoading" />
    <Popup
      :message="message"
      v-if="isPopup"
      @close="() => (isPopup = false)"
    />
    <div class="top-container-box">
      <h1>Cerita Alumni</h1>
      <div>
        <Button
          icon="+"
          outline
          name="Buat Cerita Alumni"
          style="background-color: #3b54d9; color: #ffffff; width: 250px"
          @click="() => $router.push('/alumni-stories/new')"
        />
      </div>
    </div>
    <v-row>
      <v-col cols="6">
        <div class="action-head">
          <div class="f-search">
            <div>
              <v-text-field
                v-model="filter.title"
                type="text"
                class="f-input"
                placeholder="Search..."
                clearable
                dense
                flat
                solo
                style="
                  padding-top: 5px;
                  padding-left: 5px;
                  width: 448px;
                  border-radius: 14px;
                "
                @input="() => getAlumniStories()"
              ></v-text-field>
            </div>
            <div class="f-search-ic">
              <img
                src="/img/icons/search.png"
                style="width: 100%"
                alt="Search Ic"
              />
            </div>
          </div>
        </div>
      </v-col>
    </v-row>
    <NewTable
      :headers="headers"
      :rows="alumniStories"
      :currentPage="currentPage"
      :totalPages="total"
      :totalData="totalData"
      :customColumns="customColumns"
      :perPage="perPage"
      :onEdit="editItem"
      :onView="watchItem"
      :onDelete="onDelete"
      :onPageChange="getAlumniStories"
    />
  </div>
</template>

<script>
import Button from "../../../components/Button.vue";
import Loading from "@/components/ilustration/Loading.vue";
import moment from "moment";
import Popup from "@/components/others/Popup.vue";
import NewTable from "@/components/Tabel.vue";
import getAuthentification from "@/utils/badrequest.js";

export default {
  name: "AlumniStories",
  components: {
    Button,
    Loading,
    Popup,
    NewTable,
  },
  data() {
    return {
      isLoading: false,
      currentPage: 1,
      total: 0,
      perPage: 10,
      totalData: 0,
      message: "",
      isPopup: false,
      filter: {
        title: "",
        sort_by: "desc",
      },
      filterModal: [
        {
          title: "Urutkan",
          name: "sort_by",
          items: [
            {
              name: "Terlama",
              value: "asc",
            },
            {
              name: "Terbaru",
              value: "desc",
            },
          ],
        },
      ],
      headers: [
        {
          text: "JUDUL",
          field: "title",
          width: 120,
        },
        {
          text: "CAPTION",
          field: "caption",
          width: 120,
        },
        {
          text: "TANGGAL RILIS",
          field: "date_release",
          width: 120,
        },
      ],
      alumniStories: [],
      customColumns: [
        {
          field: "is_active",
          render: (row) => {
            return `<span style="color: ${row.is_active === 'Aktif' ? 'green' : 'red'}">${row.is_active}</span>`;
          },
        },
      ],
    };
  },
  methods: {
    async getAlumniStories(page) {
      if (!page) page = this.currentPage;
      else this.currentPage = page;
      this.isLoading = true;
      
      try {
        const response = await this.$web_http.get(
          `/v1/alumni-stories?page=${page}&per_page=${this.perPage}&sort_by=${this.filter.sort_by}&title=${this.filter.title || ""}`
        );
        this.alumniStories = response.data.data.storiess.map((element) => ({
          id: element.id,
          title: element.title,
          caption: element.caption,
          date_release: this.format_date(element.date_release),
          is_active: element.is_active,
        }));
        const t = parseInt(response.data.data.total);
        this.total = Math.ceil(t / this.perPage) || 1;
        this.totalData = response.data.data.total;
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    watchItem(id) {
      this.$router.push("/alumni-stories/watch/" + id);
    },
    editItem(id) {
      this.$router.push("/alumni-stories/edit/" + id);
    },
    async onDelete(id) {
      this.isLoading = true;
      try {
        await this.$web_http.delete("/v1/alumni-stories/" + id);
        this.getAlumniStories();
      } catch (err) {
        this.message = err.response.data.data;
        this.isPopup = true;
      } finally {
        this.isLoading = false;
      }
    },
    format_date(value) {
      if (value) {
        return moment(String(value)).format("DD-MMM-YYYY");
      }
    },
    updateIsFilterActive() {
      this.isFilterActive = !(this.filter.sort_by === "desc" && !this.filter.title);
    },
  },
  beforeCreate() {
    getAuthentification();
  },
  mounted() {
    this.getAlumniStories();
  },
};
</script>

<style scoped>
.action-head {
  margin-top: 7px;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.modal-title {
  font-weight: bold;
  font-size: 19px;
}
.f-search {
  border: 1px solid #d3d6e1;
  width: 100%;
  height: 48px;
  gap: 10px;
  display: flex;
  border-radius: 10px;
  background-color: white;
}
.f-search-ic {
  display: flex;
  justify-content: center;
  align-items: center;
  width: 25px;
  margin-right: 18px;
}
.f-input {
  width: 86%;
  background: transparent;
  border: none;
}
.f-input:focus {
  background: transparent;
  border: none;
  outline-width: 0;
}
.top-container-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 30px;
}
.form-input {
  border-radius: 14px !important;
  background-color: transparent !important;
}
.count-data {
  position: relative;
  top: -60px;
  width: 30%;
}
.no-pagination {
  margin-top: 20px;
  margin-left: 5px;
}
</style>